/**
 * The hub's entry intro (2026-10-13): hall settles in depth, the band rises,
 * the stations stagger in (the CSS is under `[data-intro]` in app.css). It
 * plays once per session and never under reduced motion; storage that throws
 * (private mode, blocked cookies) just means it plays.
 */

export const INTRO_KEY = 'tallow:hub-intro';
export const INTRO_MS = 1500;

export function shouldPlayIntro(storage: Pick<Storage, 'getItem'> | null, reduced: boolean): boolean {
  if (reduced) return false;
  try {
    return !storage || storage.getItem(INTRO_KEY) !== '1';
  } catch {
    return true;
  }
}

export function playHubIntro(el: HTMLElement): boolean {
  const reduced = typeof window.matchMedia !== 'function' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let storage: Storage | null = null;
  try { storage = window.sessionStorage; } catch { storage = null; }
  if (!shouldPlayIntro(storage, reduced)) return false;
  try { storage?.setItem(INTRO_KEY, '1'); } catch { /* the intro just plays again next time */ }
  el.dataset.intro = '1';
  window.setTimeout(() => { delete el.dataset.intro; }, INTRO_MS);
  return true;
}
